import { createAction } from '@reduxjs/toolkit';
import * as filtersConstants from '../constants/filters';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const changeFilterAction = createAction<{ path: string; diff: any }>(
  filtersConstants.CHANGE_FILTER,
);

export const clearFilterAction = createAction<string>(
  filtersConstants.CLEAR_FILTER,
);

export const clearFiltersAction = () => ({
  type: filtersConstants.CLEAR_FILTERS,
});

export const setFiltersAction = (payload) => ({
  type: filtersConstants.SET_FILTERS,
  payload,
});

export const toggleFilterRegion = (payload) => ({
  type: filtersConstants.TOGGLE_FILTER_REGION,
  payload,
});
export const setMobileHotelFilterAction = createAction<boolean>(
  filtersConstants.SET_MOBILE_HOTEL_FILTER_OPENED,
);
